import dom, { Fragment } from "../../../dist/jsx-render/dom"
import JSXComponent from "../../../dist/jsx-render/JSXComponent"
import { FlexTableComponent } from "./FlexTableComponent";
import { Columns } from "./Columns";
import { app } from "../../Frame/App";
import { FlexTableRowItem } from "./FlexTableRowItem";
import { TableColumnTypes } from "./TableColumnTypes";
import { FlexFooterDoubleCell } from "./FlexFooterDoubleCell";

export type FlexFooterRowComponentProps = {
    columns: Columns;
    fixedLayout: boolean;
    flexTable: FlexTableComponent;
    idField: string;
    enableScroll: boolean;
    flexCompleteWidth: boolean;
}

export class FlexFooterRowComponent extends JSXComponent {
    props: FlexFooterRowComponentProps;
    cells: HTMLElement[] = [];
    summaryCell: HTMLElement;
    columnIdIndex: number = -1;
    doubleCells: FlexFooterDoubleCell[] = [];

    constructor(props: FlexFooterRowComponentProps) {
        super(props);
    }

    cellRowId: string = app.createGuid();
    element: HTMLElement;

    private createCells(): HTMLElement[] {
        let result: HTMLElement[] = [];
        for (let col of this.props.columns.items) {
            let cell: HTMLElement = <div className="mt-cell"><span>&nbsp;</span></div>;
            if (!this.props.fixedLayout) {
                if (col.width === 0 && col.fixedWidth) {
                    //let numericFixedWidth = +col.fixedWidth;
                    //if (isNaN(numericFixedWidth)) {
                    //    cell.style.width = col.fixedWidth;
                    //}
                    //else {
                    //    cell.style.width = numericFixedWidth.toString() + "px";
                    //}
                    cell.style.width = col.calculateWidth();
                }
                else if (col.width > 0) {
                    cell.style.width = col.width / window.devicePixelRatio + "px";
                }
                else {
                    cell.style.width = col.defaultWidth;
                }
            }

            this.cells.push(cell);
            result.push(cell);

            if (col.type == TableColumnTypes.Double) {
                this.doubleCells.push(new FlexFooterDoubleCell(cell, col.field, col.decimals));
            }
        }

        if (this.props.enableScroll && !this.props.flexCompleteWidth) {
            result.push(<div className="mt-invisible"></div>);
        }

        return result;
    }

    private createRowFixed(): HTMLElement {
        return (
            <tfoot>
                <tr id={this.cellRowId}>
                    {...this.createCells()}
                </tr>
            </tfoot>
        )
    }

    private createRowFlex(): HTMLElement {
        return (
            <div className="mt-footer-row">
                <div id={this.cellRowId} className="mt-footer-inner">
                    {...this.createCells()}
                </div>
            </div>
        )
    }

    render(): HTMLElement {
        if (this.props.fixedLayout) {
            this.element = this.createRowFixed();
        }
        else {
            this.element = this.createRowFlex();
        }

        // get id column
        if (this.props.idField) {
            for (let col of this.props.columns.items) {
                if (col.field == this.props.idField) {
                    this.columnIdIndex = col.index;
                    break;
                }
            }
        }

        return this.element;
    }

    public setColumnWidth(columnIndex: number, width: string): void {
        (document.getElementById(this.cellRowId).childNodes.item(columnIndex) as HTMLElement).style.width = width;
    }

    public updateValues(rowItems: FlexTableRowItem[]): void {
        if (this.columnIdIndex >= 0 || this.doubleCells.length > 0) {

            for (let calc of this.doubleCells) {
                calc.initCalc();
            }

            let total: number = 0;
            for (let item of rowItems) {
                if (item.isVisible) {
                    for (let calc of this.doubleCells) {
                        calc.addValue(item.model);
                    }
                    total++;
                }
            }

            if (this.columnIdIndex >= 0) {
                (this.cells[this.columnIdIndex].firstElementChild as HTMLElement).innerText = app.formatDecimalNumber(total);
            }

            for (let calc of this.doubleCells) {
                calc.updateCell();
            }

        }
    }
}
